import {Component, input, model, OnInit} from '@angular/core';
import {NgClass} from "@angular/common";
import {SERVICE_ITEMS} from "../service-box-container/items.const";
import {serviceSectionType} from "../../types/types";

@Component({
  selector: 'app-service-box-icon',
  templateUrl: './service-box-icon.component.html',
  styleUrls: ['./service-box-icon.component.scss'],
  imports: [
    NgClass
  ],
  standalone: true
})
export class ServiceBoxIconComponent implements OnInit {

  key = input<serviceSectionType>();
  icon = model<string>();
  size = input<'small' | 'medium' | 'large'>('small');


  constructor() {
  }

  ngOnInit() {

    if(!this.icon()){
      this.icon.set(SERVICE_ITEMS.find(item => item.id === this.key())?.icon);
    }

  }


}
